<template>
    <div class="div-aside">
        <h3>网站导航</h3>
        <el-row>
            <el-link type="primary" href="/#/ProductList">药品/器械 列表</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/HotNews">永安头条</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/ContactUs">联系我们</el-link>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'Aside'
    }
</script>
<style scoped>
    .div-aside{
        height: 100%;
        background-color:rgba(255, 255, 255, 0.5);
    }
    .el-link{
        font-size: 20px;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue